import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { fetchSavedParts } from "../store/parts/partsAction";
import EmptyState from "../components/saved-parts/emptyState";
import SavedPartCard from "../components/saved-parts/savedPartCard";
import CardShimmer from "../hooks/CardShimmer";
import { MessagesHeader } from "../components/conversation/Header";
import { useNavigate } from "react-router-dom";

const SavedParts = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const { savedParts, getPartLoading } = useSelector((state) => state.parts);
  const dispatch = useDispatch();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3 }
    }
  };

  const isLoading = getPartLoading;
  const hasNoSavedParts = !getPartLoading && savedParts?.length === 0;
  const hasSavedParts = !getPartLoading && savedParts?.length > 0;

  useEffect(() => {
    if (user && isAuthenticated) {
      dispatch(fetchSavedParts({ userId: user?.uid }));
    }
  }, [user, isAuthenticated, dispatch]);

  useEffect(() => {
    if (user === undefined) return;

    if (!user || !isAuthenticated) {
      navigate("/");
      return;
    }

    if (user?.role === "seller") {
      toast({
        title: "Access Denied",
        description: "You must be logged in as a Buyer to see saved parts.",
        variant: "destructive"
      });
      navigate("/dashboard");
    }
  }, [user, isAuthenticated, navigate]);

  return (
    <div className="p-4">
      <div className="py-10">
        <MessagesHeader userRole={user?.role} title={"Saved Parts"} />
      </div>
      {isLoading ? (
        <CardShimmer row={1} />
      ) : (
        <>
          {hasNoSavedParts && <EmptyState />}

          {hasSavedParts && (
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
            >
              {savedParts.map((savedPart) => (
                <motion.div
                  key={savedPart.partId || savedPart.id}
                  variants={itemVariants}
                >
                  <SavedPartCard savedPart={savedPart} />
                </motion.div>
              ))}
            </motion.div>
          )}
        </>
      )}
    </div>
  );
};

export default SavedParts;
